module.exports = __webpack_public_path__ + "static/media/splash.07ced199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/splash.jpg
// module id = 229
// module chunks = 0